// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2DkAZ","boxTitle":"Qualiphy_boxTitle__3Y2Uh","box":"Qualiphy_box__1ytQF","toggleWrap":"Qualiphy_toggleWrap__3U_gX"};